// extracted by mini-css-extract-plugin
export var testimonials = "TestimonialsLoop-module--testimonials--7f60b";
export var testimonialsContainer = "TestimonialsLoop-module--testimonials__container--b377f";
export var testimonialsContent = "TestimonialsLoop-module--testimonials__content--afaa3";
export var testimonialsSwiper = "TestimonialsLoop-module--testimonials__swiper--02ad0";